<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <!-- 25.6.11 轮播图 dxm -->
    <div
      class="swiper-container banner-swiper"
      v-if="bannerList.length > 0"
      ref="bannerDiv"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="item in bannerList"
          :key="item.id"
          :data-id="item.id"
        >
          <img :src="langSet == 'cn' ? item.image : item.en_image" alt />
        </div>
      </div>
      <!-- 展会倒计时 -->
      <div
        v-if="homeData.count_down"
        class="count_wrap flex flex_items_center"
        :style="{ top: dynamicTop + 'px' }"
      >
        <span class="count_text">{{
          langSet == "cn" ? "展会倒计时" : "Countdown"
        }}</span>
        <countdown
          v-if="homeData.count_down"
          :endDate="homeData.count_down"
        ></countdown>
        <span class="count_text">{{ langSet == "cn" ? "天" : "days" }}</span>
      </div>
    </div>
    <div class="index_wrap">
      <!-- 展会介绍 -->
      <exhibitionProfile
        v-if="homeData.area > 0"
        :webData="homeData"
      ></exhibitionProfile>
      <img
        class="home-exhibition-time"
        :src="
          langSet === 'cn'
            ? 'https://oss.chinadentalshow.com/resource/image/pc/a3784a4a7ec58fe51175f35208e54180.png'
            : 'https://oss.chinadentalshow.com/resource/image/pc/edcfcf8ab0a7d4e79f0b25ed7a9ada8b.png'
        "
        alt=""
      />
      <!-- 展会服务 企业&产品 -->
      <exhibitionServices></exhibitionServices>
      <!-- 世界口腔医学大会 -->
      <!-- 2025.10.17 隐藏  -->
      <!-- <meeting :webData="homeData"></meeting> -->
      <!-- 新闻资讯 -->
      <news></news>
      <!-- 主要合作商 -->
      <!-- 2025.10.17 隐藏 -->
      <!-- <div class="main_partners container">
        <titleConfig
          :title="langSet == 'cn' ? '首席合作商' : 'Main Sponsor'"
          :type="1"
        ></titleConfig>
        <img
          class="mp_img"
          :class="langSet != 'cn' ? 'mp_imgen' : ''"
          :src="
            langSet == 'cn' ? mainPartnerData.logo : mainPartnerData.logo_en
          "
          alt=""
        />
      </div> -->
      <!-- 合作伙伴 -->
      <div class="partner_wrap container">
        <titleConfig
          class="partner_title"
          :title="langSet == 'cn' ? '合作伙伴' : 'Our Partners'"
          :type="1"
        ></titleConfig>
        <partner v-if="partnerList.length > 0" :list="partnerList"></partner>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import exhibitionProfile from "./components/exhibitionProfile.vue";
import exhibitionServices from "./components/exhibitionServices.vue";
// import meeting from "./components/meeting.vue";
import news from "./components/news.vue";
import partner from "@/components/partner.vue";
import countdown from "@/components/countdown.vue";
import Swiper from "swiper"; // 注意引入的是Swiper
import "../../../node_modules/swiper/css/swiper.min.css"; //
import { getPartner, getMainPartner, getWebsite, slideList } from "@/api/api";
export default {
  name: "index",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.title,
      meta: [
        {
          name: "description",
          content: this.metaData.desc,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
    exhibitionProfile,
    exhibitionServices,
    // meeting,
    news,
    partner,
    countdown,
  },
  data() {
    return {
      langSet: "",
      mainPartnerData: {},
      partnerList: [],
      swiper: null,
      bannerList: [],
      dynamicTop: "360",
      homeData: {},
      metaData: {},
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
    this.metaData = JSON.parse(localStorage.getItem("metaData"));
    //25.6.11 获取轮播图 dxm
    this.getSlideList();
    //25.6.9 获取主要合作商 dxm
    this.getMainPartnerData();
    //25.6.9 获取页面基本信息
    this.getWebsiteData();
    //25.6.9 获取合作伙伴 dxm
    this.getPartnerList();
    window.addEventListener("resize", this.updateWidth);
  },
  methods: {
    updateWidth() {
      this.dynamicTop = this.$refs.bannerDiv.clientHeight / 2 - 130;
    },
    async getSlideList() {
      const res = await slideList();
      this.bannerList = res.data.lists;
      console.log(res.data.lists.length);
      let that = this;
      setTimeout(() => {
        const mySwiper = new Swiper(".banner-swiper", {
          spaceBetween: 0,
          loop: true,
          autoplay:
            this.bannerList.length > 1
              ? {
                  dealy: 3000,
                  disableOnInteraction: false,
                }
              : false,
          on: {
            tap: function (swiper, event) {
              const realIndex = mySwiper.realIndex;
              const item = that.bannerList[realIndex];
              that.toLink(item);
            },
          },
        });
      }, 300);
    },
    async getMainPartnerData() {
      const res = await getMainPartner();
      this.mainPartnerData = res.data;
    },
    async getWebsiteData() {
      let data = {
        type: "home",
      };
      const res = await getWebsite(data);
      this.homeData = res.data;
      this.homeData.count_down = new Date(this.homeData.count_down).getTime();
    },
    async getPartnerList() {
      const res = await getPartner();
      this.partnerList = res.data.lists;
    },
    toLink(item, index) {
      if (item.url_type == 1) {
        this.$router.push({
          path: this.langSet == "cn" ? item.url : item.en_url,
        });
      } else if (item.url_type == 2) {
        window.open(this.langSet == "cn" ? item.url : item.en_url, "_blank");
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
  },
};
</script>
<style lang="scss" scoped>
.home-exhibition-time {
  width: 1280px;
  display: block;
  margin: 40px auto 466px;
}
.main_partners {
  padding-top: 60px;
  .mp_img {
    width: 300px;
    margin: 25px auto 0;
  }
  .mp_imgen {
    width: 400px;
  }
}
// 合作伙伴
.partner_wrap {
  padding: 120px 0 60px;
  // background: url("../../assets/imgs/p_bg.png") no-repeat;
  // background-size: 100% 100%;
  .partner_title {
    //margin-bottom: 40px;
  }
}
// 轮播图样式
.banner-swiper {
  width: 100%;
  position: relative;
  // height: 900px;
  .swiper-wrapper {
    // display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    flex-wrap: nowrap;
    transition-property: transform;
    box-sizing: content-box;
  }
  .swiper-slide {
    width: 100% !important;
    text-align: center;
    font-size: 18px;
    background: #fff;
    cursor: pointer;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    // -webkit-justify-content: center;
    // justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .count_wrap {
    position: absolute;
    right: 80px;
    z-index: 99;
    color: #fff;
    width: auto;
    font-size: 28px;
    font-weight: 500;
    justify-content: end;
    .count_text {
      text-shadow: 0px 2px 10px rgba($color: #000000, $alpha: 0.5);
    }
  }
}

@media only screen and (max-width: 1280px) {
  .home-exhibition-time {
    width: 90%;
    display: block;
    margin: 40px auto 466px;
  }
}

@media only screen and (max-width: 767px) {
  .home-exhibition-time {
    width: 100%;
    display: block;
    padding: 0 0 1rem;
    margin: 0;
  }
  .index_wrap {
    width: 100%;
    height: auto;
    background: url("../../assets/imgs/m_bg.png") no-repeat;
    background-size: 100%;
  }
  .banner-swiper {
    height: 4.55rem;
    margin-top: 1.15rem;
    .count_wrap {
      right: 10px;
      font-size: 0.28rem;
      top: 75px !important;
    }
  }
  // 合作伙伴
  .partner_wrap {
    padding: 1.15rem 0;
    background: url("../../assets/imgs/p_bg.png") no-repeat;
    background-size: 100% 100%;
    .partner_title {
      margin-bottom: 0.23rem;
    }
  }
}
</style>